import { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "hooks/useAuth";
import ROUTES from "./NewRoutes";
import { ProtectedRoutes } from "./ProtectedRoutes";
import LoadingScreen from "modules/SubComponents/LoadingScreen";

// const Orders = lazy(()=> "../Orders/Orders"));
// const Items = lazy(()=> "../Items/Items"));
// const PendingOrders = lazy(()=> "../Orders/PendingOrders"));
// const ScrappersChecks = lazy(()=> "../ScrappersChecks"));
// const ScrappersSalesRequests = lazy(()=> './../ScrappersSalesRequests/index'));
// const RobabekiaSalesRequests = lazy(()=> './../RobabekiaSalesRequests/index'));
// const Logout = lazy(()=> "../Authentications/Logout"));
// const Types = lazy(()=> "./../Categories/index"));

const SignIn = lazy(() => import("modules/Authentications/SignIn"));
const Admins = lazy(() => import("modules/Admins/Admins"));
const Notfound = lazy(() => import("modules/Notfound/Notfound"));
const NotHaveAccess = lazy(() => import("modules/NotHaveAccess/NotHaveAccess"));
const Stores = lazy(() => import("modules/Stores"));
const Settings = lazy(() => import("modules/Settings"));
const RedeemPointsRequests = lazy(() => import("modules/RedeemPointsRequests"));
const RedeemPointsRequestsUAE = lazy(
  () => import("modules/RedeemPointsRequestsUAE"),
);
const Scrappers = lazy(() => import("modules/Scrappers/index"));
const CansSalesRequests = lazy(() => import("modules/CansSalesRequests"));
const ScrappersSalesRequestsUAE = lazy(
  () => import("modules/ScrappersSalesRequestsUAE"),
);
const SupplyingTypes = lazy(() => import("modules/SupplyingTypes"));
const AcceptedRequestsReport = lazy(
  () => import("modules/AcceptedRequestsReport"),
);
const HomeBanner = lazy(() => import("modules/HomeBanner"));
const SocialOrders = lazy(() => import("modules/SocialOrders"));
const SocialOrdersUAE = lazy(() => import("modules/SocialOrdersUAE"));
const Courier = lazy(() => import("modules/Courier"));
const CourierReport = lazy(() => import("modules/CourierReport"));
const Government = lazy(() => import("modules/Government"));
const City = lazy(() => import("modules/City"));
const DoDontImages = lazy(() => import("modules/DoDontImages"));
const StoreProducts = lazy(() => import("modules/StoreItems"));
const StoreCategories = lazy(() => import("modules/StoreCategories/index"));
const StoreSubcategories = lazy(
  () => import("modules/StoreSubcategories/index"),
);
const Notification = lazy(() => import("modules/Notification"));
const Partners = lazy(() => import("modules/Partners"));
const MarketplaceBanner = lazy(() => import("modules/MarketplaceBanner"));
const TodayCourierOrders = lazy(
  () => import("modules/TodayCourierOrders/index"),
);
const DailyCouriers = lazy(
  () => import("modules/TodayCourierOrders/DailyCouriers"),
);
const CourierCompletedOrders = lazy(
  () => import("modules/TodayCourierOrders/CourierCompletedOrders"),
);
const Partnership = lazy(() => import("modules/Partnership"));
const Chat = lazy(() => import("modules/Chat"));
const MerchantSalesRequests = lazy(
  () => import("modules/MerchantSalesRequests"),
);
const SalesRequestsReturns = lazy(() => import("modules/SalesRequestsReturns"));
const MerchantPeriods = lazy(() => import("modules/MerchantPeriods"));
const MerchantScrapTypes = lazy(() => import("modules/MerchantScrapTypes"));
const CourierDistricts = lazy(() => import("modules/CourierDistricts"));
const CommunityCategories = lazy(() => import("modules/CommunityCategories"));
const CommunitySubcategories = lazy(
  () => import("modules/CommunitySubCategories"),
);
// const PendingPosts = lazy(() => import("modules/AllPendingPosts"));
const CashTransfer = lazy(() => import("modules/CashTransfer"));
const AdminPosts = lazy(() => import("modules/AdminPosts"));
// const InstallmentPlans = lazy(() => import("modules/InstallmentPlans"));
// const InstallmentPendingOrders = lazy(() => import("modules/InstallmentPendingOrders"));
// const CustomerPaymentDues = lazy(() => import("modules/CustomerPaymentDues"));
// const InstallmentRequests = lazy(() => import("modules/InstallmentRequests"));
// const AdminPaymentDues = lazy(() => import("modules/AdminPaymentDues"));
// const InstallmentAcceptedOrders = lazy(() => import("modules/InstallmentAcceptedOrders"));
// const InstallmentStatistics = lazy(() => import("modules/InstallmentStatistics"));
const AllPendingPosts = lazy(() => import("modules/AllPendingPosts"));
const AllRejectedPosts = lazy(() => import("modules/AllRejectedPosts"));
const AcceptedPosts = lazy(() => import("modules/AcceptedPosts"));
const Merchants = lazy(() => import("modules/Merchants"));
const Buyers = lazy(() => import("modules/Buyers"));
const StockMerchantOrders = lazy(() => import("modules/StockMerchantOrders"));
const StockBuyersOrders = lazy(() => import("modules/StockBuyersOrders"));
const StockDailyCouriers = lazy(() => import("modules/StockDailyCouriers"));
const StockScrapTypes = lazy(() => import("modules/StockScrapTypes"));
// const TrackCourierDeficit = lazy(() => import("modules/TrackCourierDeficit"));
const AttributesKeys = lazy(
  () => import("modules/PostsAttributes/AttributeKeys"),
);
const LinkingAttributes = lazy(
  () => import("modules/PostsAttributes/LinkingAttributes"),
);
const CourierTracking = lazy(() => import("modules/CourierTracking"));
const InitialScrapBalance = lazy(() => import("modules/InitialScrapBalance"));
const StoreBalances = lazy(() => import("modules/StoreBalances"));
const Zones = lazy(() => import("modules/Zones"));
const Rates = lazy(() => import("modules/Rates"));
const CourierWeights = lazy(() => import("modules/CourierWeights"));
const QuestionsCategories = lazy(() => import("modules/QuestionsCategories"));
const QuestionsPage = lazy(() => import("modules/questions"));
const MerchantBuyItem = lazy(() => import("modules/MerchantBuyItem"));
const PendingMerchantBuyOrders = lazy(
  () => import("modules/PendingMerchantBuyOrders"),
);
const AllMerchantBuyOrders = lazy(() => import("modules/AllMerchantBuyOrders"));
const ScraptionCompanyPage = lazy(() => import("modules/ScraptionCompany"));
const GulfCategories = lazy(() => import("modules/GulfCategories"));
const GulfSubCategories = lazy(() => import("modules/GulfSubCategories"));
const GulfProducts = lazy(() => import("modules/GulfProducts"));
const GulfGovernment = lazy(() => import("modules/GulfGovernment"));
const GulfDistrict = lazy(() => import("modules/GulfDistrict"));
const MerchantStoreOrders = lazy(() => import("modules/MerchantStoreOrders"));
const PendingCashRequest = lazy(() => import("modules/PendingCashRequest"));
const Withdrawls = lazy(() => import("modules/AcceptedCashRequest"));

const MerchantNationalId = lazy(() => import("modules/MerchantNationalId"));
const Suppliers = lazy(() => import("modules/Suppliers"));
const PendingScrapRequest = lazy(() => import("modules/PendingScrapRequest"));
const InactiveUserRequest = lazy(() => import("modules/InactiveUserRequest"));

function RoutesFile() {
  const { isAuthorized } = useAuth();

  return (
    <Suspense fallback={<LoadingScreen />}>
      <Routes>
        <Route path={ROUTES.SIGNIN} element={<SignIn />} />

        <Route element={<ProtectedRoutes allowedRoles={[9]} />}>
          <Route path={ROUTES.RATES} element={<Rates />} />
        </Route>

        <Route element={<ProtectedRoutes allowedRoles={[1, 9, 22]} />}>
          <Route path={ROUTES.STORE_PRODUCTS} element={<StoreProducts />} />
          <Route path={ROUTES.STORE_CATEGORIES} element={<StoreCategories />} />
          <Route
            path={ROUTES.STORE_SUBCATEGORIES}
            element={<StoreSubcategories />}
          />
        </Route>

        <Route element={<ProtectedRoutes allowedRoles={[1, 9]} />}>
          {/* <Route path={ROUTES.ITEMS} element={<Items />} /> */}
          {/* <Route path={ROUTES.PENDINGORDERS} element={<PendingOrders />} /> */}
          {/* <Route path={ROUTES.Orders} element={<Orders />} /> */}
          {/* <Route path={ROUTES.DEALERSCHECKS} element={<ScrappersChecks />} /> */}

          <Route path={ROUTES.ADMINS} element={<Admins />} />
          <Route path={ROUTES.STORES} element={<Stores />} />
          <Route path={ROUTES.SETTINGS} element={<Settings />} />
          <Route path={ROUTES.SUPPLYING_TYPES} element={<SupplyingTypes />} />
          <Route path={ROUTES.HOME_BANNER} element={<HomeBanner />} />
          <Route path={ROUTES.COURIER} element={<Courier />} />
          <Route path={ROUTES.GOVERNMENT} element={<Government />} />
          <Route path={ROUTES.CTIY} element={<City />} />
          <Route path={ROUTES.ZONES} element={<Zones />} />
          <Route path={ROUTES.DO_DONT_IMAGES} element={<DoDontImages />} />
          <Route
            path={ROUTES.MARKETPLACE_BANNER}
            element={<MarketplaceBanner />}
          />
          <Route path={ROUTES.PARTNERS} element={<Partners />} />
          <Route path={ROUTES.NOTIFICATION} element={<Notification />} />

          <Route
            path={ROUTES.COURIER_DISTRICTS}
            element={<CourierDistricts />}
          />
          <Route path={ROUTES.COURIER_TRACKING} element={<CourierTracking />} />
          {/* <Route
            path={ROUTES.TRACK_COURIER_DEFICIT}
            element={<TrackCourierDeficit />}
          /> */}
          {/* <Route path={ROUTES.INSTALLMENT_PLANS} element={<InstallmentPlans />} /> */}
        </Route>

        <Route element={<ProtectedRoutes allowedRoles={[1, 9, 12, 15]} />}>
          <Route
            path={ROUTES.REDEEM_POINTS_REQUESTS}
            element={<RedeemPointsRequests />}
          />
          <Route
            path={ROUTES.REDEEM_POINTS_REQUESTS_UAE}
            element={<RedeemPointsRequestsUAE />}
          />
        </Route>

        <Route
          element={<ProtectedRoutes allowedRoles={[1, 9, 10, 12, 14, 15]} />}
        >
          <Route path={ROUTES.SOCIAL_ORDERS} element={<SocialOrders />} />
          <Route
            path={ROUTES.SOCIAL_ORDERS_UAE}
            element={<SocialOrdersUAE />}
          />
        </Route>

        <Route element={<ProtectedRoutes allowedRoles={[1, 9, 10, 14]} />}>
          <Route path={ROUTES.DAILY_COURIES} element={<TodayCourierOrders />}>
            <Route path="" element={<DailyCouriers />} />
            <Route
              path={`${ROUTES.DAILY_COURIES}${ROUTES.COMPLETED_ORDERS}`}
              element={<CourierCompletedOrders />}
            />
          </Route>
        </Route>

        <Route element={<ProtectedRoutes allowedRoles={[1, 9, 11]} />}>
          <Route path={ROUTES.DEALERS} element={<Scrappers />} />
          <Route
            path={ROUTES.ACCEPTED_REQUESTS_REPORT}
            element={<AcceptedRequestsReport />}
          />
          <Route path={ROUTES.COURIER_REPORT} element={<CourierReport />} />
          <Route
            path={ROUTES.PENDING_SCRAP_REQUEST}
            element={<PendingScrapRequest />}
          />
          <Route
            path={ROUTES.INACTIVE_USER_REQUEST}
            element={<InactiveUserRequest />}
          />
        </Route>

        <Route element={<ProtectedRoutes allowedRoles={[24]} />}>
          <Route path={ROUTES.PARTNERSHIP} element={<Partnership />} />
        </Route>

        <Route element={<ProtectedRoutes allowedRoles={[1, 9, 15]} />}>
          <Route path={ROUTES.CHAT_SCRAPPERS} element={<Chat />} />
        </Route>

        <Route element={<ProtectedRoutes allowedRoles={[1, 9, 16]} />}>
          <Route
            path={ROUTES.CHAT_SCOUTS}
            element={<Chat scoutsChat={true} />}
          />
        </Route>

        <Route element={<ProtectedRoutes allowedRoles={[1, 9, 17]} />}>
          <Route
            path={ROUTES.COMMUNITY_CATEGORIES}
            element={<CommunityCategories />}
          />
          <Route
            path={ROUTES.COMMUNITY_SUBCATEGORIES}
            element={<CommunitySubcategories />}
          />
          <Route path={ROUTES.ACCEPTED_POSTS} element={<AcceptedPosts />} />
          <Route
            path={ROUTES.ALL_PENDING_POSTS}
            element={<AllPendingPosts />}
          />
          <Route
            path={ROUTES.ALL_REJECTED_POSTS}
            element={<AllRejectedPosts />}
          />
          <Route path={ROUTES.ADMIN_POSTS} element={<AdminPosts />} />
          <Route path={ROUTES.ATTRIBUTES_KEYS} element={<AttributesKeys />} />
          <Route
            path={ROUTES.LINKING_ATTRIBUTES}
            element={<LinkingAttributes />}
          />
        </Route>

        <Route element={<ProtectedRoutes allowedRoles={[1, 9, 18]} />}>
          <Route path={ROUTES.CASH_TRANSFER} element={<CashTransfer />} />
        </Route>

        <Route element={<ProtectedRoutes allowedRoles={[1, 9, 20]} />}>
          <Route path={ROUTES.STORE_BALANCES} element={<StoreBalances />} />
          <Route path={ROUTES.STOCK_BUYERS} element={<Buyers />} />
          <Route path={ROUTES.STOCK_MERCHANTS} element={<Merchants />} />
          <Route
            path={ROUTES.STOCK_MERCHANT_ORDERS}
            element={<StockMerchantOrders />}
          />
          <Route
            path={ROUTES.STOCK_BUYER_ORDERS}
            element={<StockBuyersOrders />}
          />
          <Route
            path={ROUTES.STOCK_DAILY_COURIERS}
            element={<StockDailyCouriers />}
          />
          <Route
            path={ROUTES.STOCK_SCRAP_TYPES}
            element={<StockScrapTypes />}
          />
          <Route
            path={ROUTES.INITIAL_SCRAP_BALANCE}
            element={<InitialScrapBalance />}
          />
        </Route>

        <Route element={<ProtectedRoutes allowedRoles={[9, 10, 12, 14]} />}>
          <Route path={ROUTES.COURIER_WEIGHTS} element={<CourierWeights />} />
        </Route>

        <Route element={<ProtectedRoutes allowedRoles={[1, 9, 11, 12, 15]} />}>
          <Route
            path={ROUTES.SCRAP_SALES_REQUESTS}
            element={<CansSalesRequests />}
          />
        </Route>
        <Route element={<ProtectedRoutes allowedRoles={[1, 9, 11, 12, 15]} />}>
          <Route
            path={ROUTES.SCRAP_SALES_REQUESTS_UAE}
            element={<ScrappersSalesRequestsUAE />}
          />
        </Route>
        {/* <Route element={<ProtectedRoutes allowedRoles={[1, 9, 19]} />}>
        <Route path={ROUTES.ADMIN_PAYMENT_DUES} element={<AdminPaymentDues />} />
        <Route path={ROUTES.CUSTOMER_PAYMENT_DUES} element={<CustomerPaymentDues />} />
        <Route path={ROUTES.INSTALLMENT_PENDING_ORDERS} element={<InstallmentPendingOrders />} />
        <Route path={ROUTES.INSTALLMENT_REQUESTS} element={<InstallmentRequests />} />
        <Route path={ROUTES.INSTALLMENT_ACCEPTED_ORDERS} element={<InstallmentAcceptedOrders />} />
        <Route path={ROUTES.INSTALLMENT_STATISTICS} element={<InstallmentStatistics />} />
      </Route> */}
        <Route path={ROUTES.NOT_HAVE_ACCESS} element={<NotHaveAccess />} />
        <Route
          path={ROUTES.NOT_FOUND}
          element={
            isAuthorized ? <Notfound /> : <Navigate to={ROUTES.SIGNIN} />
          }
        />
        {/* <Route path={ROUTES.LOGOUT} element={<Logout />} /> */}
        <Route
          path={ROUTES.QUESTIONS_CATEGORIES}
          element={<QuestionsCategories />}
        />
        <Route path={ROUTES.QUESTIONS} element={<QuestionsPage />} />

        <Route element={<ProtectedRoutes allowedRoles={[1, 9, 23]} />}>
          <Route
            path={ROUTES.MERCHANT_SALES_REQUESTS}
            element={<MerchantSalesRequests />}
          />
          <Route
            path={ROUTES.SALES_REQUESTS_RETURNS}
            element={<SalesRequestsReturns />}
          />
          <Route path={ROUTES.MERCHANT_PERIODS} element={<MerchantPeriods />} />
          <Route
            path={ROUTES.MERCHANT_SCRAP_TYPES}
            element={<MerchantScrapTypes />}
          />
          <Route
            path={ROUTES.MERCHANT_BUY_ITEM}
            element={<MerchantBuyItem />}
          />
          <Route
            path={ROUTES.PENDING_MERCHANT_BUY_ORDERS}
            element={<PendingMerchantBuyOrders />}
          />
          <Route
            path={ROUTES.ALL_MERCHANT_BUY_ORDERS}
            element={<AllMerchantBuyOrders />}
          />
          <Route path={ROUTES.SUPPLIERS} element={<Suppliers />} />
          <Route
            path={ROUTES.SCRAPTION_COMPANY}
            element={<ScraptionCompanyPage />}
          />
          <Route path={ROUTES.GULF_CATEGORIES} element={<GulfCategories />} />
          <Route
            path={ROUTES.GULF_SUBCATEGORIES}
            element={<GulfSubCategories />}
          />
          <Route path={ROUTES.GULF_PRODUCTS} element={<GulfProducts />} />
          <Route path={ROUTES.GULF_GOVERMENT} element={<GulfGovernment />} />
          <Route path={ROUTES.GULF_DISTRICT} element={<GulfDistrict />} />

          <Route
            path={ROUTES.MERCHANT_STORE_ORDERS}
            element={<MerchantStoreOrders />}
          />
          <Route
            path={ROUTES.PENDING_CASH_REQUEST}
            element={<PendingCashRequest />}
          />
          <Route path={ROUTES.WITHDRAWLS} element={<Withdrawls />} />

          <Route
            path={ROUTES.MERCHANT_NATIONAL_ID}
            element={<MerchantNationalId />}
          />
        </Route>
      </Routes>
    </Suspense>
  );
}

export default RoutesFile;
